<template>
  <div class="flex items-center gap-2">
    <div
      class="w-4 h-4 flex-shrink-0 flex items-center justify-center rounded-sm bg-gray"
    >
      <icon :icon="mdiCheck" :size="IconSize.XXS" />
    </div>
    <span class="leading-none text-sm">{{ label }}</span>
  </div>
</template>

<script>
import { Icon, IconSize } from '@/components/Icon';
import { mdiCheck } from '@mdi/js';

export default {
  name: 'SurveyCheckboxOption',
  components: {
    Icon,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      IconSize,
      mdiCheck,
    };
  },
};
</script>
